export const isDiffBetweenNumbersLessOrGreaterThan = (a: number, b: number, thenNumber: number) =>
  Math.abs(a - b) > thenNumber;
